import React from 'react';
import skMessages from '../i18n/messages/sk.json';
import enMessages from '../i18n/messages/en.json';
import deMessages from '../i18n/messages/de.json';
import csMessages from '../i18n/messages/cs.json';
import { DEFAULT_LANGUAGE } from '../i18n/params';
import GlobalI18nProvider from '../../providers/I18nProvider';

const languageTranslations = {
  sk: skMessages,
  en: enMessages,
  de: deMessages,
  cs: csMessages
};

const loadMessages = locale =>
  languageTranslations[`${locale}`] || languageTranslations[`${DEFAULT_LANGUAGE}`];

const I18nProvider = ({ children }) => (
  <GlobalI18nProvider loadMessages={loadMessages} defaultLanguage={DEFAULT_LANGUAGE}>
    {children}
  </GlobalI18nProvider>
);

export default I18nProvider;
